// NexusTable/createNexusHeadersData.js

import { addPaddingRightToLastCell, headCell } from "../../modules/table.funcs"
import { COLUMN, FORMATTING, TENSE_ENUM } from "../../modules/constants"

const { border1, left } = FORMATTING
const borderLeft = border1

export const createNexusHeadersData = props => {
  // console.log('createNexusHeadersData props:', props)
  // NB: Any changes to the headCell(id) - the sort value - must be reflected in the CheatSheet headers!!
  const { isCompany, lseCompany, maxLseData, portrait, showSecondDegree, tense, the350club } = props

  const ageHead = headCell({ borderLeft, id: COLUMN.AGE })
  const compensationHead = headCell({ id: COLUMN.COMPENSATION })
  const endHead = headCell({ id: COLUMN.UNTIL, })
  const iconHead = headCell({ id: COLUMN.ICON })
  const indexHead = headCell({ align: left, id: COLUMN.LSE_INDEX })
  const nameHead = headCell({
    align: left,
    id: showSecondDegree
      ? isCompany ? COLUMN.CONNECTED_CO : COLUMN.CODIRECTOR
      : isCompany ? COLUMN.OFFICER : COLUMN.COMPANY
  })
  const overlapHead = headCell({ id: COLUMN.OVERLAP })
  const roleHead = headCell({ id: COLUMN.ROLE, align: left })
  const sexHead = headCell({ id: COLUMN.SEX })
  const showEndColumn = tense[TENSE_ENUM.PAST] || tense[TENSE_ENUM.NOTICE]
  const starHead = headCell({ id: COLUMN.STAR })
  const startHead = headCell({ borderLeft, id: COLUMN.FROM })
  const tenureHead = headCell({ id: COLUMN.TENURE })
  const viaHead = headCell({ align: left, id: isCompany ? COLUMN.VIA_PERSON : COLUMN.VIA_COMPANY })

  let headCells = [starHead, iconHead, nameHead]

  if (portrait) {
    // Add 'overlapHead or tenure'
    headCells = showSecondDegree
      ? [...headCells, viaHead, overlapHead]
      : isCompany
        ? [...headCells, roleHead, tenureHead]
        : [...headCells, indexHead, tenureHead]
  } else {
    // Add 'roleHead'
    if (!showSecondDegree)
      headCells = [...headCells, roleHead]

    // If company, add 'indexHead' before viaHead
    if (maxLseData && isCompany && showSecondDegree)
      headCells = [...headCells, indexHead]

    // If showSecondDegree add 'viaHead'
    if (showSecondDegree)
      headCells = [...headCells, viaHead]

    // If person, add 'indexHead' after viaHead
    if (maxLseData && !isCompany)
      headCells = [...headCells, indexHead]

    // Add 'startHead'
    headCells = [...headCells, startHead]

    // If showSecondDegree add 'endHead'
    if (showEndColumn)
      headCells = [...headCells, endHead]

    // Add 'overlapHead or tenure'
    headCells = showSecondDegree
      ? [...headCells, overlapHead]
      : [...headCells, tenureHead]

    if (!portrait && isCompany && !showSecondDegree) {
      headCells = (lseCompany && maxLseData)
        ? [...headCells, compensationHead, ageHead, sexHead]
        : [...headCells, ageHead]
    }

    // for a person
    if (!isCompany && maxLseData && !showSecondDegree)
      headCells.push(compensationHead)
  }

  if (the350club)
    headCells.shift() // Remove the starHead

  addPaddingRightToLastCell(headCells)

  return headCells
}

